<template>
  <div v-if="pinnedMessages.length" class="pinned-wrapper">
    <div class="pinned-card" v-if="activeMessage">
      <div class="pinned-index">
        <div
          v-for="(msg, index) in pinnedMessages"
          :key="msg.id"
          class="index-item"
          :class="{ active: index === activeIndex }"
          @click="setActive(index)"
        />
      </div>
      <div style="flex: 1; max-width: 95%">
        <div class="pinned-top">
          <div class="pinned-title">
            {{ activeMessage.title }}
          </div>
          <template v-if="editable">
            <Tooltip text="Unpin">
              <div @click.stop="handleUnpin" class="pin-icon">📌</div>
            </Tooltip>
          </template>
          <div v-else class="pin-icon">📌</div>
        </div>

        <div class="pinned-subtitle scrollable">
          {{ activeMessage.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Tooltip from "@/components/uikit/Tooltip.vue"
import { defineComponent } from "vue"

export default defineComponent({
  name: "PinnedMessages",
  components: { Tooltip },
  props: {
    editable: Boolean,
  },
  data() {
    return {
      activeIndex: 0 as number | string,
      interval: null as null | number,
    }
  },

  computed: {
    pinnedMessages() {
      return this.$store.getters["global/pinnedMessages"]
    },

    activeMessage() {
      return this.pinnedMessages[this.activeIndex]
    },
  },

  watch: {
    activeMessage: {
      handler() {
        if (!this.activeMessage && this.pinnedMessages.length) {
          this.activeIndex = this.pinnedMessages.length - 1
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.startAutoRotate()
  },

  beforeUnmount() {
    if (this.interval) clearInterval(this.interval)
  },

  methods: {
    handleUnpin(e: PointerEvent) {
      e.preventDefault()

      this.$emit("unpin", this.activeMessage)
    },
    setActive(index: number | string) {
      this.activeIndex = index

      if (this.interval) clearInterval(this.interval)

      this.startAutoRotate()
    },

    startAutoRotate() {
      this.interval = setInterval(() => {
        if (!this.pinnedMessages.length) return

        this.activeIndex = (+this.activeIndex + 1) % this.pinnedMessages.length

        if (!this.pinnedMessages[this.activeIndex]) this.activeIndex = 0
      }, 5000)
    },
  },
})
</script>

<style scoped lang="scss">
.pinned-wrapper {
  display: flex;
  align-items: stretch;
  padding: 8px 16px;
}

/* LEFT INDEX */
.pinned-index {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-top: 4px;
  height: 100%;
}

.index-item {
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  transition: 0.2s;
  flex: 1;
  color: #fff;
  height: 12px;
  width: 2.5px;
  border: navajowhite;
}

.index-item.active {
  background: #fff;
  color: #000;
  font-weight: 700;
}

/* RIGHT CARD (IMPORTANT PART) */
.pinned-card {
  flex: 1;
  cursor: pointer;
  background: #1c1f24;
  border-radius: 10px;
  padding: 10px 12px;
  position: relative;
  min-height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  flex-direction: row;
}

/* top row like screenshot */
.pinned-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pinned-title {
  font-size: 14px;
  font-weight: 900;
  color: #fff;
  line-height: 20px;
}

/* pin icon top right */
.pin-icon {
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
  font-size: 12px;
  opacity: 0.8;
}

/* subtitle */
.pinned-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 4px;
  max-height: 30px;
}
</style>
